import { type JSX, type ReactNode } from 'react';
import { Box, styled } from '@mui/material';
import { CHART_LANE_DIMMED_OPACITY } from '@/constants/PatientDashboard/patientTimeline';
import type { ChartLabelPlacement } from '@/types/PatientDashboard/PatientTimeline.types';

const MarkerWrapper = styled(Box)({
  position: 'absolute',
  transform: 'translate(-50%, -50%)',
  lineHeight: 0,
  pointerEvents: 'none',
});

const ValueLabel = styled(Box)({
  position: 'absolute',
  fontSize: '12px',
  fontWeight: 700,
  lineHeight: '130%',
  whiteSpace: 'nowrap',
  textAlign: 'center',
  pointerEvents: 'none',
});

const LABEL_OFFSET_Y: Record<ChartLabelPlacement, string> = {
  above: '-165%',
  below: '65%',
};

interface IProps {
  left: string;
  top: string;
  glyph: ReactNode;
  value?: string;
  colour?: string;
  valuePlacement?: ChartLabelPlacement;
  valueShiftPx?: number;
  markerDate?: string;
  markerId?: string;
  isDimmed?: boolean;
}

export default function ChartValueMarker({
  left,
  top,
  glyph,
  value,
  colour,
  valuePlacement = 'above',
  valueShiftPx = 0,
  markerDate,
  markerId,
  isDimmed = false,
}: IProps): JSX.Element {
  const transform = `translate(calc(-50% + ${valueShiftPx}px), ${LABEL_OFFSET_Y[valuePlacement]})`;
  const opacity = isDimmed ? CHART_LANE_DIMMED_OPACITY : undefined;

  return (
    <>
      {value !== undefined && (
        <ValueLabel
          style={{
            left, top, color: colour, transform, opacity,
          }}
        >
          {value}
        </ValueLabel>
      )}
      <MarkerWrapper
        style={{ left, top, opacity }}
        data-marker-date={markerDate}
        data-marker-id={markerId}
      >
        {glyph}
      </MarkerWrapper>
    </>
  );
}
